import ScrollUtils from "../../../util/ScrollUtils";
import $ from 'jquery';
import TemplateView from '../../../TemplateView'
import ScrollToTopButton from '../../../components/ScrollToTopButton'

export default class AutoScrollableWrapper extends TemplateView {
    constructor({
        components,
        additionalClasses = '',
        scrollEvent = 'mousemove',
        eventDataRetriever = (event, data) => event,
        enableVerticalScroll = false,
        enableHorizontalScroll = false,
        verticalScrollConfig = {},
        horizontalScrollConfig = {},
        verticalScrollContainerClass,
        horizontalScrollContainerClass,
        autoScrollEnabled = false,
        scrollOffset = 100,
        maxScrollToBottomOffset = 200,
        scrollDelta = 10,
        onScrollToBottom = () => {},
        showScrollToTopButton = false,
        scrollToTopButtonAdditionalClass = '',
        onVerticalScrollCb = (scrollPosition, maxScroll) => {},
        onHorizontalScrollCb = (scrollPosition, maxScroll) => {},
    }) {
        super()

        this.components = components
        this.additionalClasses = additionalClasses
        this.scrollToTopButtonAdditionalClass = scrollToTopButtonAdditionalClass

        this.scrollEvent = scrollEvent
        this.eventDataRetriever = eventDataRetriever
        this.enableVerticalScroll = enableVerticalScroll
        this.enableHorizontalScroll = enableHorizontalScroll

        this.verticalScrollConfig = verticalScrollConfig
        this.horizontalScrollConfig = horizontalScrollConfig

        this.verticalScrollContainerClass = verticalScrollContainerClass
        this.horizontalScrollContainerClass = horizontalScrollContainerClass

        this.autoScrollEnabled = autoScrollEnabled
        this.scrollOffset = scrollOffset
        this.maxScrollToBottomOffset = maxScrollToBottomOffset
        this.scrollDelta = scrollDelta

        this.onScrollToBottom = onScrollToBottom
        this.onVerticalScrollCb = onVerticalScrollCb
        this.onHorizontalScrollCb = onHorizontalScrollCb

        this.showScrollToTopButton = showScrollToTopButton
    }

    templateHtml() {
        return "<div class='autoScrollableWrapper scrollableContainer <%=additionalClasses%>'>" +
               "  <div class='innerScrollableContainer'></div>" +
               "  <div class='<%-scrollToTopButtonAdditionalClass%> scrollToTopButtonPlaceholder'></div>" +
               "</div>"
    }

    templateModel() {
        return {
            additionalClasses: this.additionalClasses,
            scrollToTopButtonAdditionalClass: this.scrollToTopButtonAdditionalClass
        }
    }

    afterRender() {
        this.components.forEach(c => c.init(this.find('.innerScrollableContainer')))

        if (this.enableVerticalScroll) {
            if (this.verticalScrollContainerClass) {
                this.verticalScrollConfig.appendTo = $(`.${this.verticalScrollContainerClass}`)
            }

            if (this.showScrollToTopButton) {
                this.scrollToTopButton = new ScrollToTopButton({
                    fadingHeight: 250,
                    onClickCb: () => {
                        this.scrollToTop(1000)
                        this.scrollToTopButton.fadeOut(1000)
                    },
                    scrollToTopButtonAdditionalClass: this.scrollToTopButtonAdditionalClass,
                })

                if (this.verticalScrollContainerClass)
                    this.scrollToTopButton.init($(`.${this.verticalScrollContainerClass}`))
                else
                    this.scrollToTopButton.init(this.$el)
            }

            this.verticalScroll = ScrollUtils.addVerticalScroll(this.$el, this.verticalScrollConfig)
            this.verticalScroll.on("scroll", () => {
                this._checkIfScrolledToBottom()

                if (this.showScrollToTopButton) {
                    this.scrollToTopButton.updateVisibility(this.verticalScroll.y)
                }

                this.onVerticalScrollCb(this.verticalScroll.y, this.verticalScroll.maxScrollY)
            })

            if (this.autoScrollEnabled) {
                this._subscribeVerticalScrollHandler()
            }
        }

        if (this.enableHorizontalScroll) {
            if (this.horizontalScrollContainerClass) {
                this.horizontalScrollConfig.appendTo = $(`.${this.horizontalScrollContainerClass}`)
            }
            this.horizontalScroll = ScrollUtils.addHorizontalScroll(this.$el, this.horizontalScrollConfig)

            if (this.autoScrollEnabled) {
                this._subscribeHorizontalScrollHandler()
            }

            this.horizontalScroll.on("scroll", () => {
                this.onHorizontalScrollCb(this.horizontalScroll.x, this.horizontalScroll.maxScrollX)
            })
        }

        if (!this.enableVerticalScroll && !this.enableHorizontalScroll) {
            this.getEl().off(this.scrollEvent).off('mouseout')
        }

        $(window).resizeThrottle(() => this.refreshScroll(), 100);
    }

    show() {
        super.show()
        this.refreshScroll()
    }

    refreshScroll() {
        if (this.verticalScroll) {
            ScrollUtils.refreshCustomScroll(this.verticalScroll);
            this._checkIfScrolledToBottom();

            if (this.showScrollToTopButton)
                this.scrollToTopButton.updateVisibility(this.verticalScroll.y)
        }

        if (this.horizontalScroll) {
            ScrollUtils.refreshCustomScroll(this.horizontalScroll);
        }

    }

    scrollToTop(time = 0) {
        ScrollUtils.scrollToTop(this.verticalScroll, this.getEl(), time)
    }

    _checkIfScrolledToBottom() {
        ScrollUtils.performIfScrollToBottom(this.verticalScroll, this.maxScrollToBottomOffset, () => this.onScrollToBottom())
    }

    _autoScroll(scroll, x, y) {
        scroll.scrollBy(x, y);
        this.refreshScroll()
        this._clearAutoScrollTimer()

        this.autoScrollTimer = setInterval(() => {
            scroll.scrollBy(x, y);
            this.refreshScroll()
        }, 5)
    }

    _clearAutoScrollTimer() {
        clearTimeout(this.autoScrollTimer)
    }

    _subscribeVerticalScrollHandler() {
        this.getEl().on(this.scrollEvent, (event, data) => {
            const mouseEvent = this.eventDataRetriever(event, data)

            const top = this.getEl().offset().top
            const bottom = this.getEl().offset().top + this.getEl().outerHeight()
            if (mouseEvent.clientY > bottom - this.scrollOffset && this.verticalScroll.y > this.verticalScroll.maxScrollY) {
                this._autoScroll(this.verticalScroll, 0, -this.scrollDelta)
            } else if (mouseEvent.clientY < top + this.scrollOffset && this.verticalScroll.y < 0) {
                this._autoScroll(this.verticalScroll, 0, this.scrollDelta)
            } else {
                this._clearAutoScrollTimer()
            }
        })

        this.getEl().on('mouseout', (e) => {
            this._clearAutoScrollTimer()
        })
    }

    _subscribeHorizontalScrollHandler() {
        this.getEl().on(this.scrollEvent, (event, data) => {
            const mouseEvent = this.eventDataRetriever(event, data)

            const left = this.getEl().offset().left
            const right = this.getEl().offset().left + this.getEl().outerWidth()
            if (mouseEvent.pageX < left + this.scrollOffset && this.horizontalScroll.x < 0) {
                this._autoScroll(this.horizontalScroll, this.scrollDelta, 0)
            } else if (mouseEvent.pageX > right - this.scrollOffset && this.horizontalScroll.x > this.horizontalScroll.maxScrollX) {
                this._autoScroll(this.horizontalScroll, -this.scrollDelta, 0)
            } else {
                this._clearAutoScrollTimer()
            }
        })

        this.getEl().on('mouseout', (e) => {
            this._clearAutoScrollTimer()
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/components/AutoScrollableWrapper.js